"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = exports.gifPaginator = exports.FetchError = exports.setServerUrl = exports.serverUrl = exports.GiphyFetch = void 0;
var js_util_1 = require("@giphy/js-util");
var api_1 = require("./api");
Object.defineProperty(exports, "GiphyFetch", {
  enumerable: true,
  get: function get() {
    return __importDefault(api_1).default;
  }
});
var constants_1 = require("./constants");
Object.defineProperty(exports, "serverUrl", {
  enumerable: true,
  get: function get() {
    return constants_1.serverUrl;
  }
});
Object.defineProperty(exports, "setServerUrl", {
  enumerable: true,
  get: function get() {
    return constants_1.setServerUrl;
  }
});
var fetch_error_1 = require("./fetch-error");
Object.defineProperty(exports, "FetchError", {
  enumerable: true,
  get: function get() {
    return __importDefault(fetch_error_1).default;
  }
});
__exportStar(require("./option-types"), exports);
var paginator_1 = require("./paginator");
Object.defineProperty(exports, "gifPaginator", {
  enumerable: true,
  get: function get() {
    return paginator_1.gifPaginator;
  }
});
var request_1 = require("./request");
Object.defineProperty(exports, "request", {
  enumerable: true,
  get: function get() {
    return __importDefault(request_1).default;
  }
});
__exportStar(require("./result-types"), exports);
var version = require('../package.json').version;
// since we have multiple SDKs, we're defining a hieracrchy
// Fetch API is lowest
if (!((_a = (0, js_util_1.getGiphySDKRequestHeaders)()) === null || _a === void 0 ? void 0 : _a.get("X-GIPHY-SDK-NAME"))) {
  // send headers with library type and version
  (0, js_util_1.appendGiphySDKRequestHeader)("X-GIPHY-SDK-NAME", 'FetchAPI');
  (0, js_util_1.appendGiphySDKRequestHeader)("X-GIPHY-SDK-VERSION", version);
}